








import { Component, Vue } from "vue-property-decorator";

@Component
export default class AppLayout extends Vue {
  get layout() {
    const layout = this.$route.meta.layout;
    if (!layout) return null;
    return () => import(`@/layouts/${layout}.vue`);
  }
}
